// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { type PluginListenerHandle } from "@capacitor/core";
// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Keyboard } from "@capacitor/keyboard";
import { useEffect, useState } from "react";

import { isCapacitorPlatform } from "./platformUtils";

export interface UseIsKeyboardOpenProps {
  keyboardOpenEvent?: "keyboardDidShow" | "keyboardWillShow";
}

export function useIsKeyboardOpen(props: UseIsKeyboardOpenProps = {}) {
  const { keyboardOpenEvent = "keyboardDidShow" } = props;

  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  useEffect(() => {
    if (isCapacitorPlatform()) {
      // Passing keyboardOpenEvent to the listener throws type errors,
      // overcoming it with this ugly workaround
      const keyboardOpenEventListener: Promise<PluginListenerHandle> =
        keyboardOpenEvent === "keyboardWillShow"
          ? Keyboard.addListener("keyboardWillShow", () => {
              setIsKeyboardOpen(true);
            })
          : Keyboard.addListener("keyboardDidShow", () => {
              setIsKeyboardOpen(true);
            });

      const keyboardDidHideListener = Keyboard.addListener("keyboardDidHide", () => {
        setIsKeyboardOpen(false);
      });

      return () => {
        keyboardOpenEventListener
          // eslint-disable-next-line promise/prefer-await-to-then
          .then(async (listenerHandle) => {
            await listenerHandle.remove();
          })
          // eslint-disable-next-line promise/prefer-await-to-then
          .catch(() => {
            // Ignore errors
          });
        keyboardDidHideListener
          // eslint-disable-next-line promise/prefer-await-to-then
          .then(async (listenerHandle) => {
            await listenerHandle.remove();
          })
          // eslint-disable-next-line promise/prefer-await-to-then
          .catch(() => {
            // Ignore errors
          });
      };
    }

    return undefined;
  }, [keyboardOpenEvent]);

  return isKeyboardOpen;
}
